module.exports = __webpack_public_path__ + "assets/img/dialogue_back.a62fd5a5.png";